import React, {useEffect} from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { profile } from '../../config/profile'

export default function Resume() {
    useEffect(() => {
        AOS.init({duration:1000})
    }, [])
    
    return (
        <section className="resume-area page-section scroll-to-page" id="resume">
            <div className="custom-container">
                <div className="resume-content content-width">
                    <div className="section-header">
                        <h4 className="subtitle scroll-animation" data-aos='fade-up'>
                            <i className="las la-briefcase"></i> resume
                        </h4>
                        <h1 className="scroll-animation" data-aos='fade-up'>Experience & <span>Journey</span></h1>
                    </div>

                    <div className="experience-timeline scroll-animation" data-aos='fade-up'>
                        {profile.experience.map((exp, index) => (
                            <div key={index} className="timeline-item">
                                <div className="timeline-header">
                                    <div className="company-details">
                                        <h3>{exp.title || exp.positions?.[0].title}</h3>
                                        <h4>{exp.company}</h4>
                                        <p className="duration">
                                            {exp.period || exp.positions?.[0].period} · {exp.duration}
                                        </p>
                                        <p className="location">{exp.location}</p>
                                    </div>
                                </div>

                                {/* Multiple positions at same company */}
                                {exp.positions && (
                                    <div className="positions">
                                        {exp.positions.slice(1).map((pos, idx) => (
                                            <div key={idx} className="position-item">
                                                <h4>{pos.title}</h4>
                                                <p className="duration">
                                                    {pos.period} · {pos.duration}
                                                </p>
                                                {pos.description && (
                                                    <p className="description">{pos.description}</p>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                )}

                                {/* Responsibilities */}
                                {exp.responsibilities && (
                                    <div className="responsibilities">
                                        <ul>
                                            {exp.responsibilities.map((resp, idx) => (
                                                <li key={idx}>{resp}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}

                                {/* Skills used */}
                                {exp.skills && (
                                    <div className="skills-used">
                                        {exp.skills.map((skill, idx) => (
                                            <span key={idx} className="skill-tag">{skill}</span>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}
